/**
 * Created by shubham on 8/5/18.
 */

import { Component, Inject } from '@angular/core';
import { APPCONFIG } from '../config';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../shared/services/http.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { dialogComponent } from '../dialog/dialog.component';
import { HttpHeaders } from '@angular/common/http';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';

@Component({
    selector: 'createOrUpdateUserComponent',
    template: require('./createOrUpdateUser.component.html'),
    providers: [HttpService, SessionHandler]

})
export class CreateOrUpdateUserComponent {

    dialogRef;
    userDetails: any;
    isSystemAdmin:boolean = false;
    isCountryManager:boolean = false;
    accessToken: string;
    // adminRoles = [{"id":'Admin',"name":"Admin"},{"id":'CountryManager',"name":"Country Mannager"},{"id":'User',"name":"User"}];
    // countries = [{"id":'Germany',"name":"Germany"},{"id":'France',"name":"France"},{"id":'Italy',"name":"Italy"}];
    // selectedRole = [{"id":'User',"name":"User"}];
    adminRoles = [];
    countries = [];
    selectedRole = [];
    selectedCountries = [];
    countryMessage = '';
    roleMessage = ''
    // skipManagerApprovalFlag = true;
    settings = {};
    countrySettings = {};
    languages = [];
    defaultLanguageId: any;
    AdminForm: FormGroup;
    AdminFormDetails: any;
    emailPattern = /^[a-z0-9._]+@[a-z0-9]+\.[a-z]{2,4}/;
    namePattern = /^[a-zA-Z]+(\s[a-zA-Z]+)?$/;
    
    isDisabled = true;
    report_json = {};
    action:string;
    id:string;
    user :any = {};
    showLoader = false;
    actionTitle:string;
    showCountry:boolean =true;
    constructor(private sessionHandler:SessionHandler,private router: Router, public httpService : HttpService, public dialog: MatDialog, private formBuilder: FormBuilder
    ,private activatedRoute: ActivatedRoute, private oktaAuthStateService: OktaAuthStateService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
) {
    this.oktaAuthStateService.authState$.subscribe(async (authState) => {
        if (authState.isAuthenticated) {
            const tokens = await this.oktaAuth.tokenManager.getTokens();
            this.accessToken = tokens.accessToken?.accessToken;
            this.activatedRoute.params.subscribe(params => {
                this.action = params['action'];
            });
            this.activatedRoute.queryParams.subscribe((params: Params) => {
                this.id = params['id'];
            });
            if ("Create" === this.action) {
                this.getDefaultFormData();
                this.actionTitle = "Add";
            } else {
                this.getEditForm(this.id);
                this.actionTitle = "Edit";
            }
        }
    });
}


    public onRoleSelection(item) {
        if (this.AdminFormDetails['role'] == "ADMIN") {
            this.AdminForm.removeControl('countriesData')
        } else {
            this.AdminForm.addControl('countriesData', this.formBuilder.control(null, [Validators.required]));
            this.AdminForm.get('countriesData').setValidators([Validators.required]);
        }
        var obj = { "id": -11 + '', "name": "N/A" };

        if (item.name == "ADMIN") {
            var arr = [];
            arr.push(obj);
            this.selectedCountries = arr;
            this.showCountry = false;
        } else {
            this.selectedCountries = this.selectedCountries.filter(item2 => item2.name != "N/A");
            this.showCountry = true;
        }
    }

    public getEditForm(id){
        this.showLoader = true;

        let token = localStorage.getItem('userEmail');
        const httpOptions = {
          headers : new HttpHeaders({
                'Content-Type': 'application/json',
                // 'googleEmailId': token
                'Authorization': `Bearer ${this.accessToken}`

            }) };
        this.httpService.getRequestWithHeader('users/edit/'+this.id, httpOptions).subscribe(
            res => {
                console.log(res);

                
                if(res['message'] == 'error_occured'){

                    this.showLoader = false;
        
                    this.httpService.onEnd();
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = res['exp']['message'];
        
                    this.dialogRef.afterClosed().subscribe(result => {
                        window.location.href = '#/app/users/list';
                    });
                    return;
                 }
                this.report_json = res['dataMap'];
                console.log(this.report_json);

                let rolesArr = this.report_json['roles'];
                let countriesArr = this.report_json['countries'];
                this.user = this.report_json['user'];
                
                for (var i in rolesArr) {
                    var obj = { "id": i+'', "name": rolesArr[i] };
                    this.adminRoles.push(obj);
                    if(this.user.role.indexOf(rolesArr[i])>-1){
                        this.selectedRole.push(obj);
                       }
                }
                for (var i in countriesArr) {
                    var obj = { "id": i+'', "name": countriesArr[i] };
                    this.countries.push(obj);
                    if(this.user.countries.indexOf(countriesArr[i])>-1){
                        this.selectedCountries.push(obj);
                    }
                }
                // this.selectedRole.push({ "id": selectedRoleIndex+'', "name": this.user.role });
                // this.selectedCountries = this.report_json['selectedCountries'];


                this.user.roleData = this.selectedRole;
                this.user.countriesData = this.selectedCountries;

                // this.selectedCountries.push({ "id": 0, "name": countriesArr[0] });
                this.countryMessage = "";
                this.roleMessage = "";
                this.httpService.onEnd();
                this.showLoader = false;
                this.buildForm();
                this.AdminForm.patchValue(this.user);
                
                this.onRoleSelection(this.selectedRole[0]);
                                // this.buildForm();


                },
                err => {
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';
                    this.showLoader = false;
                    this.httpService.onEnd();
                    }
        );  
    }

   public getDefaultFormData(){
    this.showLoader = true;
        let token = localStorage.getItem('userEmail');
        const httpOptions = {
          headers : new HttpHeaders({
                'Content-Type': 'application/json',
                // 'googleEmailId': token
                'Authorization': `Bearer ${this.accessToken}`
            }) };
        this.httpService.getRequestWithHeader('users/create', httpOptions).subscribe(
            res => {
                console.log(res);

                if(res['message'] == 'error_occured'){

                    this.showLoader = false;
        
                    this.httpService.onEnd();
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = res['exp']['message'];
        
                    this.dialogRef.afterClosed().subscribe(result => {
                        window.location.href = '#/app/users/list';
                    });
                    return;
                 }


                this.report_json = res['dataMap'];
                console.log(this.report_json);

                let rolesArr = this.report_json['roles'];
                let countriesArr = this.report_json['countries'];
                for (var i in rolesArr) {
                    var obj = { "id": i, "name": rolesArr[i] };
                    this.adminRoles.push(obj);
                }
                for (var i in countriesArr) {
                    var obj = { "id": i, "name": countriesArr[i] };
                    this.countries.push(obj);
                }
                // this.selectedRole.push({ "id": 0, "name": rolesArr[0] });
                // this.selectedCountries.push({ "id": 0, "name": countriesArr[0] });
                // this.countryMessage = "";
                // this.roleMessage = "";
                this.httpService.onEnd();
                this.showLoader = false;
                // this.buildForm();


                },
                err => {
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';
                    this.showLoader = false;
                    this.httpService.onEnd();
                    }
        );  
      }

      buildForm() {
        const isEdit = this.action === 'Edit';
        this.AdminForm = this.formBuilder.group({
            firstName: this.formBuilder.control(
                { value: null, disabled: isEdit }, 
                [Validators.required, Validators.pattern(this.namePattern)]
            ),
            lastName: this.formBuilder.control(
                { value: null, disabled: isEdit }, 
                [Validators.required, Validators.pattern(this.namePattern)]
            ),
            email: this.formBuilder.control(
                { value: null, disabled: isEdit }, 
                [Validators.required, Validators.pattern(this.emailPattern)]
            ),
            roleData: this.formBuilder.control(
                { value: null, disabled: isEdit }, // <-- Role is disabled in Edit mode
                [Validators.required]
            ),
            region: this.formBuilder.control(
                { value: 'EMEA', disabled: true }, 
                [Validators.required]
            ),
            countriesData: this.formBuilder.control(
                null, [Validators.required] // Only country is enabled in Edit mode
            ),
        });
    
        this.AdminForm.valueChanges.subscribe(data => {
            this.AdminFormDetails = this.AdminForm.getRawValue();
    
            this.AdminFormDetails['roleId'] = [];
            this.AdminFormDetails['countryId'] = [];
            this.AdminFormDetails['role'] = null;
            this.AdminFormDetails['countries'] = [];
    
            for (let d in this.AdminFormDetails.roleData) {
                this.AdminFormDetails['roleId'].push(this.AdminFormDetails.roleData[d]['id']);
                this.AdminFormDetails['role'] = this.AdminFormDetails.roleData[d]['name'];
            }
            for (let d in this.AdminFormDetails.countriesData) {
                this.AdminFormDetails['countryId'].push(this.AdminFormDetails.countriesData[d]['id']);
                this.AdminFormDetails['countries'].push(this.AdminFormDetails.countriesData[d]['name']);
            }
    
            if (this.AdminFormDetails['roleId'].length == 0) {
                this.AdminFormDetails.validate = false;
                this.roleMessage = "Select Role";
            } else {
                this.AdminFormDetails.validate = this.AdminForm.valid;
                this.roleMessage = '';
            }
    
            if (this.AdminFormDetails['countryId'].length == 0) {
                this.AdminFormDetails.validate = false;
                this.countryMessage = "Select Country";
            } else {
                this.AdminFormDetails.validate = this.AdminForm.valid;
                this.countryMessage = '';
            }
        });
    }

    
    public saveAdminData(){

        if(!this.AdminForm.valid==true){
            this.dialogRef = this.dialog.open(dialogComponent);
          this.dialogRef.componentInstance.msg = "Kindly fill all mandatory fields!";
         
        }else{

        const user = this.AdminFormDetails;
        user.id = this.id;
        this.showLoader = true;

        let token = localStorage.getItem('userEmail');
        const httpOptions = {
          headers : new HttpHeaders({
                'Content-Type': 'application/json',
                // 'googleEmailId': token
                'Authorization': `Bearer ${this.accessToken}`
            }) };
        this.httpService.postRequestWithHeader(user,'users/create',httpOptions).subscribe(
            res => { this.saveAdminResponse(res); 
            
            },
            err => { this.httpService.onEnd(); 
                this.showLoader = false;

            }
        );
        }
    }

    public saveAdminResponse(res){
        console.log(res);
            // var res = JSON.parse(res['_body']);
        if(res && res.message == 'success'){
          
            this.showLoader = false;

            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(dialogComponent);
            if(this.action=='Edit'){
                this.dialogRef.componentInstance.msg = "User updated successfully.";
            }else{
                this.dialogRef.componentInstance.msg = "User added successfully.";
            }
            this.dialogRef.afterClosed().subscribe(result => {
                window.location.href = '#/app/users/list';
            });
        }else if(res && res.message == 'error_occured'){

            this.showLoader = false;

            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.exp.message;

        
         } else {
            this.showLoader = false;

            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Not able to save details. Please try again.';
            this.httpService.onEnd();
        }
    }

    ngOnInit() {
        this.buildForm();

        this.settings = {
            singleSelection: true,
            text:"Select Role *",
            labelKey: "name",
            // selectAllText:'Select All',
            // unSelectAllText:'UnSelect All',
            classes:"myclass custom-class"
        };

        this.countrySettings = {
            singleSelection: false,
            text:"Select Country *",
            labelKey: "name",
            badgeShowLimit: 5,
            classes:"myclass custom-class"
        };
    }
}